import MiniFaqs, { MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import BankDetailsModule from '@/containers/BankDetailsModule';
import { USER_STATUSES } from '@/helpers/constants';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { SuspendResidenceWarning } from '@/components/Warnings/SuspendResidenceWarning';
import s from './index.module.scss';

const PaymentsBankDetailsPage = () => {
  const { user } = useGetMe();

  if (user?.status === USER_STATUSES.suspended) {
    return (
      <div className={s.wrapper}>
        <SuspendResidenceWarning />
      </div>
    );
  }

  return (
    <div className={s.wrapper}>
      <BankDetailsModule />
      <MiniFaqs source={MINIFAQ_SOURCES.bankDetails} />
    </div>
  );
};

export default PaymentsBankDetailsPage;
